////////LIBRARY/////////
import React, { Component } from 'react'
import { Link } from 'react-router'
import { connect } from 'react-redux'
///////COMPONENTS///////
import menuParts from './menuParts'
import styles from './styles'
import { List, ListItem } from 'material-ui/List'

class POPMenu extends Component {
  constructor(props) {
    super(props)
    this.state = { value: 1 }
  }

	///////////////////////////////// RENDER ///////////////////////////////////////

  render() {
    const { dropdowns, dashboard, followUp, deliveryFollowUp, myAccount, productionFollowUp } = menuParts
    const { trl, companyIsPrintshopProd } = this.props

    return (
      <div className="leftMenu">
        <List>
          <ListItem
            primaryText={trl[dashboard.text]}
            style={styles.menuItem}
            containerElement={<Link to={dashboard.link} />}
          />
          <ListItem
            primaryText={trl[followUp.text]}
            style={styles.menuItem}
            containerElement={<Link to={followUp.link} />}
          />
          {
            companyIsPrintshopProd &&
            <ListItem
              primaryText={trl[productionFollowUp.text]}
              style={styles.menuItem}
              containerElement={<Link to={productionFollowUp.link} />}
            />
          }
          <ListItem
            primaryText={trl[deliveryFollowUp.text]}
            style={styles.menuItem}
            containerElement={<Link to={deliveryFollowUp.link} />}
          />
          <ListItem
            primaryText={trl[dropdowns.myAccount.text]}
            initiallyOpen={false}
            style={styles.menuItem}
            primaryTogglesNestedList={true}
            className="nestedMenu"
            nestedItems={[
              <ListItem
                key={1}
                primaryText={trl[myAccount.text]}
                style={styles.menuItem}
                containerElement={<Link to={myAccount.link} />}
              />
            ]}
          />
        </List>
      </div>
    )
  }
}
const mapStateToProps = ({ me }) => ({
  companyIsPrintshopProd: me.is_PrintShop_Prod,
})
export default connect(
  mapStateToProps,
  null
)(POPMenu)
